import { useMemo } from "react";
import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getAuthorOrderHistory } from "../service";

export const useAuthorOrderHistory = (strategyId, options = {}) => {
  const { enabled = true, ...restOptions } = options;

  const query = useInfiniteQuery({
    queryKey: ["authorOrderHistory", strategyId],
    queryFn: ({ pageParam = 1 }) =>
      getAuthorOrderHistory(strategyId, { page: pageParam, size: 10 }),
    getNextPageParam: (lastPage) =>
      lastPage?.page < lastPage?.total_pages ? lastPage.page + 1 : undefined,
    enabled: enabled && !!strategyId,
    ...restOptions,
  });

  const { data } = query;

  const derived = useMemo(() => {
    if (!data?.pages?.length) {
      return {
        transactions: [],
        totalPages: 0,
        totalCount: 0,
        currentPage: 1,
      };
    }

    const latestPage = data.pages.at(-1);

    return {
      transactions: data.pages.flatMap((p) => p.data),
      totalPages: latestPage.total_pages,
      totalCount: latestPage.total_count,
      currentPage: latestPage.page,
    };
  }, [data]);

  return {
    ...query,
    ...derived,
  };
};
